<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Consulting',

    metaInfo: { title: 'Consulting & Real Estate' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-field',
        'field-services',
        'photo-gallery',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'about',
      },
    },
  }
</script>
